const currentYear = new Date().getFullYear()
const yearValue = currentYear === 2022 ? currentYear : `2022-${currentYear}`

const appConfig = {
    title: 'RetuRO',
    copyright: `Copyright © ${yearValue} RetuRO`,
}

export default appConfig
